"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleRegistrationNumberWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var components_1 = require("@athena-portal/components");
var journey_services_1 = require("@ferry/journey-services");
var FalconQuestionWidgetBase_1 = require("../FalconQuestionWidgetBase");
var VehicleRegistrationNumberWidget = /** @class */ (function (_super) {
    __extends(VehicleRegistrationNumberWidget, _super);
    function VehicleRegistrationNumberWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeyPress = function (event) {
            if (event.key === "Enter") {
                // @ts-ignore
                document.getElementById("input-label").click();
            }
        };
        _this.handleChange = function (event) {
            event.preventDefault();
            _this.validate(event);
            var vrn = event.target.value.trim().toUpperCase();
            _this.setState({ vrn: vrn });
            _this.props.onStateChange(_this.props.question.interactionField, vrn);
            _this.executeNativeEvent(event);
            _this.changelogRecorder.recordQuestion("change", _this.props);
            _this.setState({
                registrationNumberDisabled: !journey_services_1.VEHICLE_REG_NUMBER_REGEX.test(vrn)
            });
        };
        _this.inputLabel = document.getElementById("input-label");
        if (_this.inputLabel) {
            _this.inputLabel.addEventListener("keydown", _this.handleKeyPress.bind(_this));
        }
        _this.state = {
            vrn: _this.bindFromField(_this.props.question.interactionField) || "",
            file: null,
            showOverlay: false,
            registrationNumberDisabled: _this.isRegistrationNumberDisabled()
        };
        _this.validate = _this.validate.bind(_this);
        return _this;
    }
    VehicleRegistrationNumberWidget.prototype.renderInputField = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "row w-100 m-0 vrn-widget", children: [(0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, jsx_runtime_1.jsx)("div", { className: "col-md-7 d-flex p-0 vrn-text-box", children: (0, jsx_runtime_1.jsx)("input", { onInput: this.handleChange, onBlur: function (event) { return _this.validate(event); }, onFocus: this.executeNativeEvent, onClick: this.executeNativeEvent, value: this.state.vrn, type: "text", id: "registrationNumber", maxLength: 7, className: "form-control vrn-input-field ".concat(this.getInputValidationClass()) }) }), (0, jsx_runtime_1.jsx)("div", { className: "col-md-5 pr-0 pl-7 pl-md-3 pt-3 pt-md-0 mobile-button-position", children: (0, jsx_runtime_1.jsx)("button", { type: "submit", disabled: this.state.registrationNumberDisabled, className: "btn btn-default btn-primary btn-next float-right m-0-desktop m-10-mobile", children: "Find my car" }) })] }), (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: this.state.showOverlay })] }));
    };
    VehicleRegistrationNumberWidget.prototype.validate = function (event) {
        this.validateInternal(event.target.value);
        this.executeNativeEvent({
            type: "validatePage"
        });
    };
    ;
    VehicleRegistrationNumberWidget.prototype.isRegistrationNumberDisabled = function () {
        var _a, _b, _c;
        return !(((_a = this.props.interaction) === null || _a === void 0 ? void 0 : _a.process) === journey_services_1.INTERACTION_PROCESS_NB && ((_c = (_b = this.props.interaction) === null || _b === void 0 ? void 0 : _b.vehicles[0]) === null || _c === void 0 ? void 0 : _c.registrationNumber));
    };
    return VehicleRegistrationNumberWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.VehicleRegistrationNumberWidget = VehicleRegistrationNumberWidget;
//# sourceMappingURL=VehicleRegistrationNumberWidget.js.map